import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation, useParams, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux'

import DataTable from 'datatables.net-react'
import DT from 'datatables.net'
import $ from 'jquery' // For getting into DataTables search :-/

import Checkbox from '../../../components/psc/lib/Checkbox'
import MultiSelect from '../../../components/psc/lib/MultiSelect'
import { CopyTextToClipboard } from '../../../obj/history';
import Applicability from '../../../components/psc/lib/Applicability'

import useDocumentStatuses from '../../../hooks/useDocumentStatuses'
import useCustomerDocumentStatuses from '../../../hooks/useCustomerDocumentStatuses'
import useSupplierDocumentStatuses from '../../../hooks/useSupplierDocumentStatuses'
import useRecordStatuses from '../../../hooks/useRecordStatuses'

DataTable.use(DT)

const Edit = (props) => {
    const table = useRef([])
    const [hasAccess, setHasAccess] = useState(true)
    const [tableData, setTableData] = useState(null)

    const reportID = props.reportID
    const reportSchemeID = props.reportSchemeID

    const reportModels = props.reportModels
    const setReportModels = props.setReportModels
    
    const reportDocumentStatuses = props.reportDocumentStatuses
    const reportIncludedDocumentStatuses = props.reportIncludedDocumentStatuses
    const reportCustomerDocumentStatuses = props.reportCustomerDocumentStatuses
    const reportRecordStatuses = props.reportRecordStatuses
    const reportSupplierDocumentStatuses = props.reportSupplierDocumentStatuses

    const setReportDocumentStatuses = props.setReportDocumentStatuses
    const setReportIncludedDocumentStatuses = props.setReportIncludedDocumentStatuses
    const setReportCustomerDocumentStatuses = props.setReportCustomerDocumentStatuses
    const setReportRecordStatuses = props.setReportRecordStatuses
    const setReportSupplierDocumentStatuses = props.setReportSupplierDocumentStatuses

    const reportDocuments = props.reportDocuments
    const reportIncludedDocuments = props.reportIncludedDocuments
    const reportCustomerDocuments = props.reportCustomerDocuments
    const reportRecords = props.reportRecords
    const reportSupplierDocuments = props.reportSupplierDocuments

    const setReportDocuments = props.setReportDocuments
    const setReportIncludedDocuments = props.setReportIncludedDocuments
    const setReportCustomerDocuments = props.setReportCustomerDocuments
    const setReportRecords = props.setReportRecords
    const setReportSupplierDocuments = props.setReportSupplierDocuments

    const hasModels = props.hasModels

    const disabled = props.disabled
    const hasStages = props.hasStages

    const tblOrder = localStorage.tblReportContentsOrder
    ? JSON.parse(localStorage.tblReportContentsOrder)
    : [[ 2, 'asc' ]]

    const pscState = useSelector(state => state.pscState.value)
    const project = pscState.project

    const { documentStatuses } = useDocumentStatuses()
    const includedDocumentStatuses = documentStatuses
    //const supplierDocumentStatuses = documentStatuses // TODO fuck sake probably wrong
    const { customerDocumentStatuses } = useCustomerDocumentStatuses()
    const { supplierDocumentStatuses } = useSupplierDocumentStatuses()
    const { recordStatuses } = useRecordStatuses()

    const [allowedContentLoaded, setAllowedContentLoaded] = useState(false)
    const [allowedContent, setAllowedContent] = useState([])      
    const [sections, setSections] = useState([])

    useEffect(() => {
        if ( ! reportSchemeID ) {
            return
        }
        fetch('/v0/report_schemes/' + reportSchemeID + '/configuration/' + project.id, { credentials: 'same-origin' })
            .then(function(response) {
                return response.json()
            })
            .then(function(json) {
                if(json.error) {
                    alert('Error: ' + json.error)
                    return
                }
                setSections(json.result.sections)
                setAllowedContent(json.result.allowed_content)
                setAllowedContentLoaded(true)
            })
    }, [reportSchemeID, project])

    useEffect(() => {
        // Set default filters on NEW reports
        
        if (!Number.isNaN(reportID)) {
            return
        }
        const default_filter = hasStages
            ? (item) => item.label === 'Live' || item.label === 'Filed'
            : (item) => item.label !== 'Withdrawn'
        
        setReportDocumentStatuses(documentStatuses.filter( default_filter ))
        setReportIncludedDocumentStatuses(includedDocumentStatuses.filter( default_filter ))
        setReportCustomerDocumentStatuses(customerDocumentStatuses.filter( default_filter ))
        setReportRecordStatuses(recordStatuses.filter( default_filter ))
    }, [reportID])

    useEffect(() => {
        if( ! allowedContentLoaded ) {
            return
        }
        filterContent()
    }, [reportDocumentStatuses, reportIncludedDocumentStatuses, reportCustomerDocumentStatuses, reportSupplierDocumentStatuses, reportRecordStatuses, reportModels, allowedContentLoaded, tableData])

    useEffect(() => {
        table.current = table.current.slice(0, sections.length);
     }, [sections])

    useEffect(() => {
        if( ! allowedContentLoaded ) {
            return
        }
        let allTableData = []
        sections.forEach(section => {
            section.check_all = false

            let tblData = allowedContent.filter(c => c.section_id === section.id)
            // Start with all hidden
            tblData = tblData.map(c => { c.is_hidden = true; c.is_included = false; return c })
            allTableData.push(tblData)
        })
        setTableData(allTableData)
    }, [allowedContentLoaded, allowedContent])

    useEffect(() => {
        // TODO figure out how to do this with tableRef.
        $.fn.dataTable.ext.search = [
            function( settings, data, dataIndex ) {
                const isHidden = data[0]
                return isHidden === "true" ? false : true
            }
        ]
    }, [table])

    const savedOrder = localStorage.getItem('tblReportContentsOrder')
    const initialOrder = savedOrder ? JSON.parse(savedOrder) : [[ 2, 'asc' ]]

    const options = {
        lengthMenu: [ 1000, 2000 ],
        pageLength: 1000,
        autoWidth: false,
        order: initialOrder,
        dom: 'fgtp',
        paging: false,
        // This is used to highlight conflicting entries
        fnRowCallback: (nRow, aData, iDisplayIndex ) => {
            const conflictClass = "conflict_" + aData.section_id + "_" + aData.content_id
            nRow.className = conflictClass
        },
    }

    const columns = [
        { data: 'is_hidden', visible: false },
        { data: 'is_included', sortable: false },
        { data: 'final_version_file_path', orderSequence: ['asc', 'desc'] },
        { data: 'cadm_object_name', orderSequence: ['asc', 'desc'] },
        { data: 'reference', orderSequence: ['asc', 'desc'] },
        { data: 'title', orderSequence: ['asc', 'desc'] },
        { data: 'status', orderSequence: ['asc', 'desc'] }
    ]

    const tableHead = (section) => (
        <tr>
            <th></th>
            <th style={{width: '10px'}}>
            <Checkbox
                    onChange={(event) => toggleCheckAll(event, section)}
                    isChecked={section.check_all}
                    disabled={disabled}
                />
            </th>
            <th style={{width: '10px'}}>&nbsp;</th>
            <th>Configured Item</th>
            <th>Reference</th>
            <th>Title</th>
            <th>Status</th>
        </tr>
    )
 
    const tableFoot = (section) => (
        <tr>
            <th></th>
            <th style={{width: '10px'}}>&nbsp;</th>
            <th style={{width: '10px'}}>&nbsp;</th>
            <th>Configured Item</th>
            <th>Reference</th>
            <th>Title</th>
            <th>Status</th>
        </tr>
    )
 
    const tableSlots = {
        1: (data, type, row) => {
            if( type !== 'display') {
                return data
            }
            return (
                <Checkbox
                    onChange={() => toggleRoleCheckbox(row)}
                    isChecked={data}
                    disabled={disabled}
                />
            )
        },
        2: (data, type, row) => {
            if (data === '') return ''
            if (data.match(/^http/i)) {
                return (
                    <a href={data} target="_blank" rel="noreferrer" data-tooltip-id="gnctooltip" data-tooltip-content="Open Document">
                        <i className="fa fa-file-o"></i>
                    </a>
                )
            }
            return (
                <a href="#" onClick={(e) => { e.preventDefault(); CopyTextToClipboard(e, data)}} data-tooltip-id="gnctooltip" data-tooltip-content="Copy Filepath to Clipboard">
                    <i className="fa fa-copy"></i>
                </a>
            )
        },
        4: (data, type, row) => {
            if( type !== 'display') {
                return data
            }
            const url = "/portfolio/"+project.id+"/"+row.cadm_object_href+"/"+row.content_id
            return (<span className="highlight_error">{data} <a href={url} target="_blank" rel="noreferrer"><i className="fa fa-external-link "></i></a></span>)
        },
    }

    const hasContent = (content) => {
        const type = content.cadm_object_href
        const id = content.content_id
        const report_type_section_id = content.section_id

        // type = ( documents, customer_documents, records )
        switch (type) {
            case 'documents':
                return reportDocuments.some(item => id === item.document_id && report_type_section_id === item.report_type_section_id)
            case 'included_documents':
                return reportIncludedDocuments.some(item => id === item.included_document_id && report_type_section_id === item.report_type_section_id)
            case 'customer_documents':
                return reportCustomerDocuments.some(item => id === item.customer_document_id && report_type_section_id === item.report_type_section_id)
            case 'supplier_documents':
                return reportSupplierDocuments.some(item => id === item.supplier_document_id && report_type_section_id === item.report_type_section_id)
            case 'records':
                return reportRecords.some(item => id === item.record_id && report_type_section_id === item.report_type_section_id)
            default:
                return false
        }
    }

    const setContent = (contents) => {
        let report = {
            documents: [],
            included_documents: [],
            customer_documents: [],
            supplier_documents: [],
            records: [],
        }
        contents.forEach(content => {
            const conflictClass = ".conflict_" + content.section_id + "_" + content.content_id
            if( ! content.is_included ) {
                $(conflictClass).removeClass("error")
                return
            }
            const type = content.cadm_object_href
            const id = content.content_id
            const key = type.replace(/s$/,'') + '_id'
            const report_type_section_id = content.section_id
            const reference_without_version = content.reference_without_version
            // If there is any other versions of the same doc, mark it as conflicting
            const conflict = hasStages && contents.find((elem) => elem.is_included
                                                && elem.content_id !== id
                                                && elem.reference_without_version === content.reference_without_version
            ) !== undefined
                           ? true
                           : false
            content.conflict = conflict
            conflict ? $(conflictClass).addClass("error") : $(conflictClass).removeClass("error");
            
            report[type].push({ [key]: id, report_type_section_id: report_type_section_id,
                reference_without_version: reference_without_version, conflict: conflict })
        })
        setReportDocuments(report.documents)
        setReportIncludedDocuments(report.included_documents)
        setReportCustomerDocuments(report.customer_documents)
        setReportSupplierDocuments(report.supplier_documents)
        setReportRecords(report.records)
    }
         
    const filterContent = () => {
        if( tableData === null ) {
            return
        }

        let modelMap = {}
        reportModels.forEach(function (item) {
            modelMap[ item.project_system_model_id ] = true
        })

        let statusMap = {}
        statusMap.customer_documents = {}
        statusMap.supplier_documents = {}
        statusMap.documents = {}
        statusMap.included_documents = {}
        statusMap.records = {}

        reportDocumentStatuses.map(item => statusMap.documents[ item.label ] = true)
        reportIncludedDocumentStatuses.map(item => statusMap.included_documents[ item.label ] = true)
        reportCustomerDocumentStatuses.map(item => statusMap.customer_documents[ item.label ] = true)
        reportSupplierDocumentStatuses.map(item => statusMap.supplier_documents[ item.label ] = true)
        reportRecordStatuses.map(item => statusMap.records[ item.label ] = true)
        
        // Straight edit datatable data
        let allContent = []
        table.current.forEach( t => {
            t.dt().rows().every( (index) => {
                const row = t.dt().row(index)
                const content = row.data()

                content.is_hidden = false
                if( ! statusMap[ content.cadm_object_href ][ content.status ] ) {
                    content.is_hidden = true
                }
    
                // only filter on models if the project got any models associated with it
                let number_of_systems = project.project_systems.length
                if( number_of_systems === 1 && ( ! project.project_systems[0].project_system_models || project.project_systems[0].project_system_models.length === 0 ) ) {
                    // no models
                } else {
                    if( ! content.project_system_model_id.some(function(item) {
                        return modelMap[ item ] ? true : false
                    })) {
                        content.is_hidden = true
                    }
                }
    
                if( content.is_hidden ) {
                    content.is_included = false
                } else {
                    content.is_included = hasContent(content)
                }

                row.data(content)
                allContent.push(content)
                return true
            })
        })
        $('.dataTable').DataTable()?.search()
        $('.dataTable').DataTable()?.draw('')
        setContent(allContent)
    }

    const toggleRoleCheckbox = (item) => {
        const isIncluded = !item.is_included

        // Straight edit datatable data
        let allContent = []
        table.current.forEach( t => {
            t.dt().rows().every( (index) => {
                const row = t.dt().row(index)
                const data = row.data()
                if( data.section_id === item.section_id && data.cadm_object_href === item.cadm_object_href && data.content_id === item.content_id ) {
                    data.is_included = isIncluded
                    row.data(data)
                }
                allContent.push(data)
                return true
            })
        })
        setContent(allContent)
    }

    const toggleCheckAll = (event, section) => {
        const isIncluded = event.target.checked

        setSections(sections.map(function (item) {
            item = { ...item } // clone it
            if( item.id === section.id ) {
                item.check_all = isIncluded
            }
            return item
        }))

        let allContent = []
        table.current.forEach( t => {
            t.dt().rows().every( (index) => {
                const row = t.dt().row(index)
                const data = row.data()
                if( data.section_id === section.id && ! data.is_hidden) {
                    data.is_included = isIncluded
                    row.data(data)
                }
                allContent.push(data)
                return true
            })
        })
        setContent(allContent)
    }
    
    const renderSystems = () => {
        return (
            <Applicability
                label="Report filter"
                introText="Filter content with the following Product Tree items."
                projectId={project.id}
                projectType={project.project_type.name}
                options={project.project_systems}
                value={reportModels}
                onChange={(models) => {
                        setReportModels(models)
                    }}
                disabled={disabled}
            />
        )
    }

    const renderStatusItem = (name, options, value, onChange) => {
        return (
            <div className="col-sm-4 m-b-xs" key={name}>
                {name} Status
                <MultiSelect
                    options={options}
                    value={value}
                    onChange={(value) => {
                            onChange(value)
                        }}
                    disabled={disabled}
                />
            </div>
        )
    }
    
    const renderStatus = () => {
        return (
            <div className="form-group">
                <label className="col-sm-2 control-label">Status</label>
                <div className="col-sm-8">
                    <div className="row form-text" key="status-container-1">
                        {renderStatusItem('Customer Document', customerDocumentStatuses, reportCustomerDocumentStatuses, setReportCustomerDocumentStatuses)}
                        {/* renderStatusItem('Supplier Document', supplierDocumentStatuses, reportSupplierDocumentStatuses, setReportSupplierDocumentStatuses) */}
                        {renderStatusItem('Document', documentStatuses, reportDocumentStatuses, setReportDocumentStatuses)}
                        {renderStatusItem('Included Document', includedDocumentStatuses, reportIncludedDocumentStatuses, setReportIncludedDocumentStatuses)}
                    </div>
                    <div className="row form-text" key="status-container-2">
                        {renderStatusItem('Record', recordStatuses, reportRecordStatuses, setReportRecordStatuses)}
                    </div>
                </div>
            </div>
        )
    }
    
    const renderAllowedContent = () => {
        if( ! reportSchemeID || reportSchemeID === 0 ) {
            return null
        }
        
        if( ! allowedContentLoaded ) {
            return <h1>Loading...</h1>
        }
        
        if( tableData === null ) {
            return null
        }

        return (
            <div className="form-group">
                <label className="col-sm-2 control-label"> </label>
                <div className="col-sm-8">
                    <div className="row">

                        <div className="col-sm-12 m-b-xs">
                            <div>
                                <div>
                                    {sections.map(function (section, index) {
                                        return (
                                            <div key={section.title}>
                                                <h3>{section.title}</h3>
                                                <DataTable
                                                    className="table table-striped table-bordered table-hover"
                                                    options={options}
                                                    columns={columns}
                                                    ref={el => table.current[index] = el}
                                                    data={tableData[index]}
                                                    slots={tableSlots}
                                                    onOrder={(e, settings, order) => {
                                                            if( ! order.length ) {
                                                                return
                                                            }
                                                            const value = [[ order[0].col, order[0].dir ]]
                                                            localStorage.setItem('tblReportContentsOrder', JSON.stringify(value))
                                                        }}
                                                >
                                                    <thead>
                                                        {tableHead(section)}
                                                    </thead>
                                                    <tfoot>
                                                        {tableFoot(section)}
                                                    </tfoot>
                                                </DataTable>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
        
    return (
        <div>
            <div className="form-group">
                <label className="col-sm-2"></label>
                <div className="col-sm-8">
                    <h3>Report Content</h3>
                    <p>
                        View and edit your report content.
                    </p>
                </div>
            </div>
            
            {renderStatus()}
            
            <div className="hr-line-dashed"></div>
            
            {renderSystems()}
            
            {renderAllowedContent()}
                    
        </div>
    )
}

export default Edit
